export const fmtCost = (c) => {
  const v = Number(c || 0);
  if (v === 0) return '$0.00';
  return v >= 1 ? `$${v.toFixed(2)}` : `$${v.toFixed(4)}`;
};
export const fmtInt = (n) => Number(n || 0).toLocaleString('de-DE');
export const fmtTokens = (n) => {
  const v = Number(n || 0);
  if (v >= 1e6) return `${(v / 1e6).toFixed(2)} M`;
  if (v >= 1e3) return `${(v / 1e3).toFixed(1)} k`;
  return String(v);
};
export const fmtAt = (iso) => iso ? new Date(iso).toLocaleString('de-DE', { day: '2-digit', month: '2-digit', hour: '2-digit', minute: '2-digit' }) : '—';
export const fmtDay = (d) => d ? `${d.slice(8, 10)}.${d.slice(5, 7)}.` : '';

const iso = (d) => d.toISOString().slice(0, 10);

export const PERIODS = [
  { id: 'month', label: 'Dieser Monat' },
  { id: 'last_month', label: 'Letzter Monat' },
  { id: '30d', label: '30 Tage' },
  { id: '90d', label: '90 Tage' },
  { id: 'custom', label: 'Zeitraum' },
];

export function periodRange(id) {
  const now = new Date();
  const utc = new Date(Date.UTC(now.getUTCFullYear(), now.getUTCMonth(), now.getUTCDate()));
  if (id === 'last_month') {
    const first = new Date(Date.UTC(utc.getUTCFullYear(), utc.getUTCMonth() - 1, 1));
    const last = new Date(Date.UTC(utc.getUTCFullYear(), utc.getUTCMonth(), 0));
    return { from: iso(first), to: iso(last) };
  }
  if (id === '30d' || id === '90d') {
    const start = new Date(utc); start.setUTCDate(start.getUTCDate() - (id === '30d' ? 29 : 89));
    return { from: iso(start), to: iso(utc) };
  }
  return { from: iso(new Date(Date.UTC(utc.getUTCFullYear(), utc.getUTCMonth(), 1))), to: iso(utc) };
}
